<template>
  <v-container transparent>
    <v-layout>
      <v-card width="100%" class="px-3" flat>

        <v-toolbar flat class="py-3" color="white" :clipped="$vuetify.breakpoint.lgAndUp">
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-toolbar-title class="mt-1 mr-3">Ритейл коды</v-toolbar-title>
            <v-divider class="mx-2" inset vertical></v-divider>
          </template>
          <v-btn flat class="mt-3" @click="loadRetailRegDataList()">
            <v-icon class="notranslate">refresh</v-icon>
            <template v-if="$vuetify.breakpoint.smAndUp">&nbsp;Обновить</template>
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn flat class="mt-3" @click="exportDataList()">
            <v-icon class="notranslate">exit</v-icon>
            <template v-if="$vuetify.breakpoint.smAndUp">&nbsp;Экспорт в XLS</template>
          </v-btn>
          <v-btn flat class="mt-3" @click="exportDataListToGoogle()">
            <v-icon class="notranslate">exit</v-icon>
            <template v-if="$vuetify.breakpoint.smAndUp">&nbsp;Экспорт в Google doc</template>
          </v-btn>
          <v-spacer></v-spacer>
          <v-dialog v-model="utility.dialog" background="#fff" max-width="900px">
            <template v-slot:activator="{ on }">
              <v-btn flat color="primary" class="mt-3" v-on="on">
                <v-icon class="notranslate">add</v-icon>
                <template v-if="$vuetify.breakpoint.smAndUp">Зарегистрировать отчет</template>
                <template v-else>отчет</template>
              </v-btn>
            </template>
            <RegRetail
                v-on:close-dlg="utility.dialog = false"
                v-on:reload-list="loadRetailRegDataList()"
                v-bind:reg-id="editedId"
                in-modal="true">
            </RegRetail>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-text-field
              v-model="utility.search"
              append-icon="search"
              label="Поиск"
              single-line
              hide-details
              class="hidden-sm-and-down notranslate"
          ></v-text-field>
        </v-toolbar>
        <v-toolbar flat dense class="py-3" color="white" :clipped="$vuetify.breakpoint.lgAndUp" v-if="false">
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <div class="mt-1 mr-3">Фильтр:</div>
          </template>
        </v-toolbar>

        <v-data-table class="py-3"
                      :headers="headers"
                      :items="retail_reg_data"
                      :loading="utility.dataLoading"
                      :search="utility.search"
                      :rows-per-page-items='[ 10, 25, 50, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]'
                      pagination.sync="{rowsPerPage:10}"
        >
          <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.code }}</td>
            <td class="text-xs-left">{{ isCompleteC(props.item.isComplete) }}</td>
            <td class="text-xs-left">{{ props.item.name }}
              {{ props.item.tutor_name ? ' - (' + props.item.tutor_name + ')' : '' }}
            </td>
            <td class="text-xs-left">{{ props.item.birthday }}</td>
            <td class="text-xs-left">{{ props.item.email }}</td>
            <td class="text-xs-left">{{ props.item.tel }}</td>
            <td class="text-xs-left">{{ props.item.delivery_datetime }}</td>
            <td class="text-xs-left">{{ props.item.delivery_address }}</td>
            <td class="text-xs-left">
              <v-icon class="notranslate" @click="editItem(props.item)">edit</v-icon>
            </td>
            <td class="text-xs-left">
              <v-icon class="notranslate" @click="deleteItem(props.item)">delete</v-icon>
            </td>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning" class="notranslate">
              По ключевым словам "{{ utility.search }}" ничего не найдено.
            </v-alert>
          </template>
        </v-data-table>
        <br/>

        <v-layout wrap>
          <v-flex xs7>
            <v-textarea prepend-icon="key" rows=10 name="reg_report_delivery_address" class="notranslate"
                        label="Пакетный импорт кодов" v-model="import_data"
                        type="text"
            ></v-textarea>
            <div class="text--darken-4 red--text pl-5 pr-3 pb-3">При импорте без заголовков используется только первый столбец данных как поле `code`.
              <br>При импорте с заголовками можно импортировать любые поля коллекции: [code, code1, code2, name, tutor_name, isComplete, birthday, email, tel, delivery_datetime, delivery_address]</div>
          </v-flex>
          <v-flex xs1>
          </v-flex>
          <v-flex xs4>
            <v-btn large color="primary"
                   :disabled="!import_data"
                   @click="importBulkData">Импортировать
            </v-btn>
            <v-switch class="notranslate"
                      label="Удалить старые данные перед импортом"
                      v-model="cleanup_data_on_import"
            ></v-switch>
            <v-switch class="notranslate"
                      label="Первый ряд как заголовки"
                      v-model="import_no_headers"
            ></v-switch>

          </v-flex>
        </v-layout>

      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import RegRetail from "./RegRetail"
import {excelParser} from "../excel-parser"

import {csv} from 'csvtojson';
import {GoogleSpreadsheet} from 'google-spreadsheet'
import creds from '/gdoc_creds.json'

//API key AIzaSyDkzKt8hjGt-Alej55zQ1j2FmEUj7uI1X4
//Doc id 1RzfM3rjaHFMMIo8IaVNI89AoUGRmWpuJSvquBenISa8

export default {
  name: "retailRegDataList",
  components: {
    RegRetail
  },
  data: () => ({
    regReportFormValid: false,

    retail_reg_data: [],

    editedId: "",
    utility: {
      dataLoading: true,
      search: '',
      dialog: false
    },
    import_data: "",
    cleanup_data_on_import: false,
    import_no_headers: false,
    rules: {
      required: value => !!value || 'Required.',
      isValidJson: value => {
        if (!value) return false;
        try {
          if (JSON.parse(value)) return false;
        } catch {
          return 'Not valid JSON.';
        }
        return 'Not valid JSON.';
      },
      counter: value => value.length <= 20 || 'Max 20 characters'
    }
  }),
  methods: {
    closeDialog: function () {
      this.editedId = ""
      this.utility.dialog = false
    },
    importBulkData: function () {
      var this_ = this;
      let importData = []

      csv({
        delimiter: '\t',
        noheader: !this_.import_no_headers,
        // , 'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'a10'
       //headers: this_.import_no_headers ? ['code'] : null
      }).fromString(this_.import_data).then((csvRow) => {
        console.log(csvRow)
        for (let idx in csvRow) {
          importData.push(
              (!this_.import_no_headers) ? {
                code: csvRow[idx].field1,
                code1: "",
                code2: "",
                name: "",
                tutor_name: "",
                isComplete: "",
                birthday: "",
                email: "",
                tel: "",
                delivery_datetime: "",
                delivery_address: ""
              } : {
                code: csvRow[idx].code,
                code1: csvRow[idx].code1 || "",
                code2: csvRow[idx].code2 || "",
                name: csvRow[idx].name || "",
                tutor_name: csvRow[idx].tutor_name || "",
                isComplete: csvRow[idx].isComplete || 0,
                birthday: csvRow[idx].birthday || "",
                email: csvRow[idx].email || "",
                tel: csvRow[idx].tel || "",
                delivery_datetime: csvRow[idx].delivery_datetime || "",
                delivery_address: csvRow[idx].delivery_address || ""
              }
          )
        }
        console.log(importData)

        this.$store.dispatch('adminRetailBulkImport', {
          cleanup: this_.cleanup_data_on_import,
          list: importData
        }).then(function (response) {
          this_.response = response
          if (this_.response.status !== 200) {
            this_.$store.dispatch('processError', this_.response)
          }
          this_.utility.dataLoading = false
          if (this_.response.status === 200) {
            this_.loadRetailRegDataList()
          }
        })
      })
    },

    exportDataList: function () {
      var this_ = this;
      excelParser().exportDataFromJSON(this_.retail_reg_data, null, null);
    },

    exportDataListToGoogle: async function () {
      var this_ = this;

      const doc = new GoogleSpreadsheet('1RzfM3rjaHFMMIo8IaVNI89AoUGRmWpuJSvquBenISa8');
      await doc.useServiceAccountAuth(creds);
      await doc.loadInfo()
      const sheet = doc.sheetsByIndex[0];
      await sheet.clear();
      await sheet.setHeaderRow([
        'Код', //'Код 1', 'Код 2', 'Зарегистрирован',
        'ФИО', 'ФИО опекуна', 'ДР', 'Email', 'Телефон',
        'Адрес доставки', 'Дата доставки']);

      let normalizedData = []
      for (let idx in this_.retail_reg_data) {
        let item = this_.retail_reg_data[idx]
        if (item.isComplete) {
          normalizedData.push([
            item.code,
            /*  item.code1,              item.code2,              item.isComplete?'Да':'Нет',*/
            item.name, item.tutor_name || '', item.birthday,
            item.email, item.tel, item.delivery_address, item.delivery_datetime
          ])
        }

      }
      await sheet.addRows(normalizedData);
    },

    isCompleteC(value) {
      return value ? 'yes' : 'no'
    },

    loadRetailRegDataList: function () {
      var this_ = this;
      this_.utility.dataLoading = true
      this.$store.dispatch('adminRetailRegList', {}).then(function (response) {
        this_.response = response
        if (this_.response.status != 200) {
          this_.$store.dispatch('processError', this_.response)
        }
        this_.utility.dataLoading = false
        if (this_.response.status === 200) {
          this_.retail_reg_data = this_.response.data.retail_reg_data
          // console.log(this_.retail_reg_data)
        }
      })
    },
    editItem(item) {
      this.editedId = item.code
      this.utility.dialog = true
    },
    deleteItem(item) {
      var this_ = this;
      this_.utility.dataLoading = true
      this.$store.dispatch('adminRetailDelete', {code: item.code}).then(function (response) {
        this_.response = response
        if (this_.response.status != 200) {
          this_.$store.dispatch('processError', this_.response)
        }
        this_.utility.dataLoading = false
        if (this_.response.status === 200) {
          this_.loadRetailRegDataList()
          // console.log(this_.retail_reg_data)
        }
      })

    }
  },
  watch: {
    "utility.dialog": function (val) {
      if (!val) this.editedId = ""
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Code',
          align: 'left',
          sortable: true,
          value: 'code'
        },
        {text: 'Заполнен', value: 'isComplete'},
        {text: 'Имя', value: 'name'},
        {text: 'ДР', value: 'birthday'},
        {text: 'Email', value: 'email'},
        {text: 'Tel', value: 'tel'},
        {text: 'Дата курьера', value: 'delivery_datetime'},
        {text: 'Адрес', value: 'delivery_address'},

        {text: 'Ред.', value: '_id'},
      ]
    },
  }
  ,
  created: function () {
    this.loadRetailRegDataList()
  }
}
</script>

<style type="scss" scoped>
</style>